import React, {useContext, useRef, useState} from "react";
import {useHistory} from "react-router-dom";
import {useDispatch} from "react-redux";
import useAuth from "../Hooks/useAuth";
import {Scrollbars} from "rc-scrollbars";
import classnames from "classnames";
import {useTranslation} from "react-i18next";
import keys from "../translations/keys";
import Footer from "../Components/Footer";
import PaymentsList from "./Main/PaymentsList";
import Image from "react-image-webp";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {Carousel} from 'react-responsive-carousel';
import Button from "../Components/Button";
import ReactPlayer from "react-player";
import {CSSTransition, SwitchTransition} from "react-transition-group";
import _ from "underscore";
import {Modal} from "semantic-ui-react";
import {useModalState} from "../Hooks/useModalState";
import {LanguageContext} from "../Context/LanguageContext";
import {Languages} from "../Components/translations/types";
import ShowBackground from "../Components/SnowBackground";
import usePublicSubscriptionPrices from "../Hooks/usePublicSubscriptionPrices";
import {formatPrice, getPriceDays} from "../Hooks/usePayment";
import "../Styles/SubscriptionPrices.scss";

const svg = <svg width="27" height="30" viewBox="0 0 27 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M3.47524 9.31382L3.59348 10.0544H3.59348L3.47524 9.31382ZM9.24784 3.49504L9.98874 3.61146L9.24784 3.49504ZM23.1374 27.6631L23.5805 28.2682L23.1374 27.6631ZM24.6737 26.1145L24.0653 25.676L24.6737 26.1145ZM2.32627 26.1145L2.9347 25.676L2.32627 26.1145ZM3.8626 27.6631L3.41947 28.2682L3.8626 27.6631ZM3.8626 2.33688L3.41947 1.73179L3.8626 2.33688ZM2.32627 3.8855L2.9347 4.32404L2.32627 3.8855ZM23.1374 2.33688L23.5805 1.73179L23.1374 2.33688ZM24.6737 3.8855L24.0653 4.32404L24.6737 3.8855ZM9.33333 1.0405L9.30745 0.290947L9.33333 1.0405ZM1.04018 9.4L0.290612 9.37452L1.04018 9.4ZM14.8889 19.85C14.4747 19.85 14.1389 20.1858 14.1389 20.6C14.1389 21.0142 14.4747 21.35 14.8889 21.35V19.85ZM19.0556 21.35C19.4698 21.35 19.8056 21.0142 19.8056 20.6C19.8056 20.1858 19.4698 19.85 19.0556 19.85V21.35ZM7.94444 14.25C7.53023 14.25 7.19444 14.5858 7.19444 15C7.19444 15.4142 7.53023 15.75 7.94444 15.75V14.25ZM19.0556 15.75C19.4698 15.75 19.8056 15.4142 19.8056 15C19.8056 14.5858 19.4698 14.25 19.0556 14.25V15.75ZM14.8889 8.65C14.4747 8.65 14.1389 8.98579 14.1389 9.4C14.1389 9.81421 14.4747 10.15 14.8889 10.15V8.65ZM19.0556 10.15C19.4698 10.15 19.8056 9.81421 19.8056 9.4C19.8056 8.98579 19.4698 8.65 19.0556 8.65V10.15ZM3.59348 10.0544C6.88916 9.52828 9.4682 6.92432 9.98874 3.61146L8.50693 3.37862C8.0862 6.05626 6.00427 8.15056 3.357 8.5732L3.59348 10.0544ZM0.25 13.6V16.4H1.75V13.6H0.25ZM26.75 16.4V13.6H25.25V16.4H26.75ZM13.5 29.75C16.0871 29.75 18.0882 29.751 19.6686 29.5785C21.2633 29.4043 22.5184 29.0461 23.5805 28.2682L22.6943 27.058C21.9309 27.6171 20.9713 27.9273 19.5057 28.0873C18.0257 28.249 16.1208 28.25 13.5 28.25V29.75ZM25.25 16.4C25.25 19.0414 25.249 20.9627 25.0885 22.4557C24.9295 23.935 24.6211 24.9048 24.0653 25.676L25.2822 26.553C26.0526 25.4841 26.4074 24.2215 26.5799 22.616C26.751 21.0242 26.75 19.0082 26.75 16.4H25.25ZM23.5805 28.2682C24.2337 27.7898 24.8079 27.211 25.2822 26.553L24.0653 25.676C23.6829 26.2065 23.2202 26.6729 22.6943 27.058L23.5805 28.2682ZM0.25 16.4C0.25 19.0082 0.248986 21.0242 0.420078 22.616C0.592641 24.2215 0.947377 25.4841 1.71784 26.553L2.9347 25.676C2.37889 24.9048 2.07049 23.935 1.91149 22.4557C1.75101 20.9627 1.75 19.0414 1.75 16.4H0.25ZM13.5 28.25C10.8792 28.25 8.97429 28.249 7.49428 28.0873C6.02867 27.9273 5.06907 27.6171 4.30574 27.058L3.41947 28.2682C4.48159 29.0461 5.73671 29.4043 7.33144 29.5785C8.91178 29.751 10.9129 29.75 13.5 29.75V28.25ZM1.71784 26.553C2.19208 27.211 2.76627 27.7898 3.41947 28.2682L4.30574 27.058C3.77985 26.6729 3.31713 26.2065 2.9347 25.676L1.71784 26.553ZM3.41947 1.73179C2.76627 2.21017 2.19208 2.78902 1.71784 3.44696L2.9347 4.32404C3.31712 3.79346 3.77985 3.32711 4.30574 2.94197L3.41947 1.73179ZM13.5 1.75C16.1208 1.75 18.0257 1.75105 19.5057 1.91268C20.9713 2.07274 21.9309 2.38294 22.6943 2.94197L23.5805 1.73179C22.5184 0.953941 21.2633 0.595704 19.6686 0.421543C18.0882 0.248954 16.0871 0.25 13.5 0.25V1.75ZM26.75 13.6C26.75 10.9918 26.751 8.97582 26.5799 7.38401C26.4074 5.77852 26.0526 4.5159 25.2822 3.44696L24.0653 4.32404C24.6211 5.09516 24.9295 6.06498 25.0885 7.54431C25.249 9.03734 25.25 10.9586 25.25 13.6H26.75ZM22.6943 2.94197C23.2202 3.32711 23.6829 3.79346 24.0653 4.32404L25.2822 3.44696C24.8079 2.78902 24.2337 2.21017 23.5805 1.73179L22.6943 2.94197ZM13.5 0.25C11.8807 0.25 10.4959 0.249905 9.30745 0.290947L9.35922 1.79005C10.5162 1.7501 11.8723 1.75 13.5 1.75V0.25ZM9.30745 0.290947C6.70857 0.3807 4.87543 0.665514 3.41947 1.73179L4.30574 2.94197C5.36257 2.16799 6.7798 1.87913 9.35922 1.79005L9.30745 0.290947ZM8.58333 1.04049C8.58332 2.34144 8.58019 2.91236 8.50693 3.37862L9.98874 3.61146C10.0847 3.00082 10.0833 2.28689 10.0833 1.04051L8.58333 1.04049ZM1.75 13.6C1.75 11.9594 1.75009 10.5921 1.78975 9.42548L0.290612 9.37452C0.249908 10.5721 0.25 11.9676 0.25 13.6H1.75ZM1.78975 9.42548C1.87815 6.82442 2.16497 5.39196 2.9347 4.32404L1.71784 3.44696C0.66192 4.91194 0.379618 6.75586 0.290612 9.37452L1.78975 9.42548ZM1.04018 10.15C2.27604 10.15 2.986 10.1514 3.59348 10.0544L3.357 8.5732C2.89612 8.64678 2.33143 8.64999 1.04017 8.65L1.04018 10.15ZM14.8889 21.35H19.0556V19.85H14.8889V21.35ZM7.94444 15.75H19.0556V14.25H7.94444V15.75ZM14.8889 10.15H19.0556V8.65H14.8889V10.15Z"
        fill="#FAFAFA"/>
</svg>

const links = [
    'https://youtu.be/OsjLRz_ysGM',
    'https://youtu.be/jXVtJEIBSg0',
    'https://youtu.be/O33UNijKh3w',
    'https://youtu.be/wFoI3RcRkeU',
    'https://youtu.be/Ku8dWBiPrxA',
]

const WelcomePage = () => {
    const {prices: subscriptionPrices} = usePublicSubscriptionPrices();
    const {lang} = useContext(LanguageContext);
    const dispatch = useDispatch()
    const {state, isAuthenticated} = useAuth()
    const [top, setTop] = useState(0);
    const [carouselIndex, setCarouselIndex] = useState(0);
    const carouselImageRef = useRef<HTMLDivElement>(null);
    const {t} = useTranslation();
    const [selectedVideo, setSelectedVideo] = useState(_.random(links.length - 1))
    const {onClose, onOpen, isOpen, onToggle} = useModalState();
    const reSelectVideo = () => {
        setSelectedVideo(_.random(links.length - 1));
    }

    const history = useHistory();
    const onLogin = async () => {
        await state.LoginAction();
    };

    const logout = async () => {
        await state.LogoutAction();
    }

    const getStickyTopClasses = () => {
        return classnames('welcome-page-top', {'welcome-page-top-show': top <= 0.9})
    }

    const getStickyTopClasses2 = () => {
        return classnames('functions-top', {'functions-top-show': top > 0.9})
    }

    const topPanel = () => {
        return <div className="welcome-page__top">
            <div className="welcome-page__top__part">
                <div className="top__item logo"><Image webp={'/WelcomePage/divine-logo-white.webp'}
                                                       src='/divine-logo-white.png' alt={'logo'}/></div>
                <div className="top__item title">D I V I N E</div>
            </div>
            <div className="welcome-page__top__part">
                {/*<div className="top__item top__item--link">*/}
                {/*    <div className="top__item__icon">*/}
                {/*        <svg width="28" height="30" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
                {/*            <path*/}
                {/*                d="M17.4211 5.47704C22.8098 8.60213 25.5042 10.1647 26.4085 12.2047C27.1972 13.984 27.1972 16.016 26.4085 17.7953C25.5042 19.8353 22.8098 21.3979 17.4211 24.523C12.0323 27.6481 9.33787 29.2106 7.12691 28.9772C5.19842 28.7736 3.44651 27.7576 2.30673 26.1818C1 24.3753 1 21.2502 1 15C1 8.74982 1 5.62473 2.30673 3.81816C3.44651 2.24239 5.19842 1.22641 7.12691 1.02282C9.33787 0.7894 12.0323 2.35195 17.4211 5.47704Z"*/}
                {/*                stroke="#FAFAFA" stroke-width="1.5"/>*/}
                {/*        </svg>*/}
                {/*    </div>*/}
                {/*    <div className="top__item__icon__text">{t(keys.welcomePage.top.stream)}</div>*/}
                {/*</div>*/}
                <a href={'/contacts'} className="top__item top__item--link">
                    <div className="top__item__icon">{svg}</div>
                    <div className="top__item__icon__text">{t(keys.welcomePage.contacts)}</div>
                </a>
                <a href={'Docs/terms_of_use.pdf'} className="top__item top__item--link">
                    <div className="top__item__icon">{svg}</div>
                    <div className="top__item__icon__text">{t(keys.welcomePage.agreement)}</div>
                </a>
                <a href={'Docs/privacy_policy.pdf'} className="top__item top__item--link">
                    <div className="top__item__icon">{svg}</div>
                    <div className="top__item__icon__text">{t(keys.welcomePage.privacy)}</div>
                </a>
                <div className="top__item top__item--hoverable" onClick={onLogin}>
                    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M7.42404 12.7935C10.6193 12.7935 13.2092 10.2479 13.2092 7.10867C13.2092 3.96943 10.6193 1.42505 7.42404 1.42505C4.22874 1.42505 1.63773 3.96943 1.63773 7.10867C1.62694 10.2373 4.19997 12.7829 7.38328 12.7935L7.42404 12.7935Z"
                              stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <svg width="21" height="11" viewBox="0 0 21 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd"
                              d="M10.067 1.84607C5.21225 1.84607 1.06641 2.60052 1.06641 5.62203C1.06641 8.64353 5.18595 9.42502 10.067 9.42502C14.9218 9.42502 19.0664 8.66933 19.0664 5.64906C19.0664 2.62878 14.9481 1.84607 10.067 1.84607Z"
                              stroke="#E93E2C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    {/*<CSSTransition>*/}
                    <div className="top__item--action top__item--link"
                         onClick={onLogin}>{t(keys.welcomePage.login)}</div>
                    <div className="top__item--action top__item--link"
                         onClick={onLogin}>{t(keys.welcomePage.registration)}</div>
                    {/*</CSSTransition>*/}

                </div>

            </div>
        </div>
    }

    const carouselItem1 = () => {
        return <div className="carousel__item carousel__item--1">
            <div className="carousel__item__background carousel__item__background-image">
                {/*D I V I N E*/}
                <Image webp={'/carousel/item1_text.webp'} src={'/carousel/item1_text.png'}/>
            </div>
            {/*<div className="carousel__item__background sf">*/}
            {/*    <img src={'/sf.png'}/>*/}
            {/*</div>*/}
            <div className="carousel__item__content">
                <div className="carousel__item__title">{t(keys.welcomePage.carousel.one.title)}</div>
                <div className="carousel__item__text">
                <span>
                    {t(keys.welcomePage.carousel.one.text)}
                    <span className="carousel__item__text--highlighted">
                        DOTA 2
                    </span>
                </span>
                </div>
                <div className="carousel__item__actions">
                    <Button as={'a'}
                            href={`${window.location.origin}/about`}>{t(keys.welcomePage.carousel.one.action)}</Button>
                    <Button as={'a'}
                            href={`${window.location.origin}/buy`}>{t(keys.welcomePage.carousel.one.action2)}</Button>
                </div>
            </div>
        </div>
    }
    const carouselItem2 = () => {
        return <div className="carousel__item carousel__item--2">
            <div className="carousel__item__background carousel__item__background-image">
                {/*D I S C O R D*/}
                <Image webp={'/carousel/item2_text.webp'} src={'/carousel/item2_text.png'}/>
            </div>
            <div className="carousel__item__content">
                <div className="carousel__item__title">{t(keys.welcomePage.carousel.two.title)}</div>
                <div className="carousel__item__text">
                <span>
                    {t(keys.welcomePage.carousel.two.text)}
                    <span className="carousel__item__text--highlighted carousel__item__text--blue">
                        DISCORD
                    </span>
                    {t(keys.welcomePage.carousel.two.text2)}
                </span>
                </div>
                <div className="carousel__item__actions">

                    <Button disabled>{t(keys.welcomePage.carousel.two.action)}</Button>
                    <Button as={'a'}
                            href={`https://discord.gg/YvFuC6H`}>{t(keys.welcomePage.carousel.two.action2)}</Button>
                </div>
            </div>
        </div>
    }
    const carouselItem3 = () => {
        return <div className="carousel__item carousel__item--3">
            <div className="carousel__item__background carousel__item__background-image">
                {/*D I V I N E*/}
                <Image webp={'/carousel/item3_text.webp'} src={'/carousel/item3_text.png'}/>
            </div>
            <div className="carousel__item__content">
                <div className="carousel__item__title">{t(keys.welcomePage.carousel.three.title)}</div>
                <div className="carousel__item__text">
                <span>
                    {t(keys.welcomePage.carousel.three.text)}
                    <span className="carousel__item__text--highlighted carousel__item__text--green">
                        09K
                    </span>
                    {t(keys.welcomePage.carousel.three.text2)}
                </span>
                </div>
                <div className="carousel__item__actions">
                    <Button as={'a'}
                            href={'https://www.youtube.com/channel/UCwvspR1m7BbrfCmojC72jBA'}>{t(keys.welcomePage.carousel.three.action)}</Button>
                    <Button as={'a'}
                            href={`${window.location.origin}/buy`}>{t(keys.welcomePage.carousel.three.action2)}</Button>
                </div>
            </div>
        </div>
    }
    const carouselItem4 = () => {
        return <div className="carousel__item carousel__item--4">
            <div className="carousel__item__background carousel__item__background-image">
                {/*V K . C O M*/}
                <Image webp={'/carousel/item4_text.webp'} src={'/carousel/item4_text.png'}/>
            </div>
            <div className="carousel__item__content">
                <div className="carousel__item__title">{t(keys.welcomePage.carousel.four.title)}</div>
                <div className="carousel__item__text">
                <span>
                    {t(keys.welcomePage.carousel.four.text)}
                    <span className="carousel__item__text--highlighted carousel__item__text--super-blue">
                        {t(keys.welcomePage.carousel.four.text2)}
                    </span>
                    <span className="carousel__item__text--highlighted carousel__item__text--super-blue">
                        DIVINE
                    </span>
                    {t(keys.welcomePage.carousel.four.text3)}
                </span>
                </div>
                <div className="carousel__item__actions">
                    <Button disabled>{t(keys.welcomePage.carousel.four.action)}</Button>
                    <Button as={'a'}
                            href={`https://vk.com/divinecheat`}>{t(keys.welcomePage.carousel.four.action2)}</Button>
                </div>
            </div>
        </div>
    }
    const carouselItem5 = () => {
        return <div className="carousel__item carousel__item--5">
            <div className="carousel__item__background carousel__item__background-image">
                {/*V I C T O R Y*/}
                <Image webp={'/carousel/item5_text.webp'} src={'/carousel/item5_text.png'}/>
            </div>
            <div className="carousel__item__content">
                <div className="carousel__item__title">{t(keys.welcomePage.carousel.five.title)}</div>
                <div className="carousel__item__text">
                <span>
                    {t(keys.welcomePage.carousel.five.text)}
                    <span className="carousel__item__text--highlighted carousel__item__text--water-blue">
                        DODGER
                    </span>
                    {t(keys.welcomePage.carousel.five.text2)}
                </span>
                </div>
                <div className="carousel__item__actions">
                    <Button as={'a'}
                            href={'https://www.youtube.com/channel/UCwvspR1m7BbrfCmojC72jBA'}>{t(keys.welcomePage.carousel.five.action)}</Button>
                    <Button as={'a'}
                            href={`${window.location.origin}/buy`}>{t(keys.welcomePage.carousel.five.action2)}</Button>
                </div>
            </div>
        </div>
    }


    const welcomeText = () => {
        return <div className="welcome-page__welcome-text">
            <div className="welcome-page__welcome-text--wrapper">
                <div className="welcome-text__title">{t(keys.welcomePage.welcomeText.title)}</div>
                <div className="welcome-text__description">{t(keys.welcomePage.welcomeText.text)}</div>
            </div>

        </div>
    }
    const carousel = () => {
        const onChangeHandler = (index: number, item: React.ReactNode) => {
            // console.log('onChangeHandler', index, item)
            setCarouselIndex(index);
        }

        const renderIconByIndex = () => {
            const cls = classnames('carousel-image__wrapper', {
                [`carousel-image__wrapper--${carouselIndex}`]: true
            })
            return <div className={cls}>
                <SwitchTransition>
                    <CSSTransition
                        key={carouselIndex}
                        nodeRef={carouselImageRef}
                        timeout={500}
                        classNames='fade'
                    >
                        <div ref={carouselImageRef}>
                            <Image className={'carousel-image'} webp={`/carousel/item${carouselIndex + 1}.webp`}
                                   src={`/carousel/item${carouselIndex + 1}.png`}/>
                        </div>
                        {/*{carouselIndex === 1 &&*/}
                        {/*<Image className={'carousel-image'} webp={`/carousel/item${carouselIndex + 1}_extra.webp`}*/}
                        {/*       src={`/carousel/item${carouselIndex + 1}_extra.png`}/>}*/}
                        {/*<Image src={}*/}
                        {/*<button onClick={() => setState(state => !state)}>*/}
                        {/*    {state ? "Goodbye, world!" : "Hello, world!"}*/}
                        {/*</button>*/}
                    </CSSTransition>
                </SwitchTransition>
            </div>
        }

        return <div className="welcome-page__carousel">
            <div className="welcome-page__carousel--wrapper">
                <Carousel
                    autoPlay={true} showArrows={false} showThumbs={false} showStatus={false} infiniteLoop={true}
                    emulateTouch={false} swipeable={true} stopOnHover autoFocus={false} onChange={onChangeHandler}>
                    <div>
                        {carouselItem1()}
                    </div>
                    <div>
                        {carouselItem2()}
                    </div>
                    <div>
                        {carouselItem3()}
                    </div>
                    <div>
                        {carouselItem4()}
                    </div>
                    <div>
                        {carouselItem5()}
                    </div>
                </Carousel>
                {renderIconByIndex()}
            </div>

        </div>
    }

    const justDescription = () => {
        return <div className="welcome-page__just-description">
            <div className="just-description__title">{t(keys.welcomePage.description)}</div>
            <div className="just-description__image">
                <Image webp={'/WelcomePage/description.webp'} src={'/WelcomePage/description.png'}/>
                {/*<img src={'/WelcomePage/description.png'}/>*/}
            </div>
        </div>
    }

    const halloween = () => {
        // return <div className="halloween xmas">
        return <div className="xmas">
            <ShowBackground/>
            <div className="window">
                <div className="santa">
                    <div className="head">
                        <div className="face">
                            <div className="redhat">
                                <div className="whitepart"></div>
                                <div className="redpart"></div>
                                <div className="hatball"></div>
                            </div>
                            <div className="eyes"></div>
                            <div className="beard">
                                <div className="nouse"></div>
                                <div className="mouth"></div>
                            </div>
                        </div>
                        <div className="ears"></div>
                    </div>
                    <div className="body"></div>
                </div>
            </div>
            <div className="message">
                <h1>Merry Christmas!</h1>
                <h2 className="copyright">{t(keys.welcomePage.halloween.text)}</h2>
                <h2 className="copyright">{t(keys.welcomePage.halloween.text2)}</h2>
            </div>
        </div>;
        return <div className="halloween">
            <Image src={'/WelcomePage/halloween.png'} webp={'/WelcomePage/halloween.webp'}/>
            <div className="halloween__description">
                <span>{t(keys.welcomePage.halloween.text)}</span>
                <span>{t(keys.welcomePage.halloween.text2)}</span>
                <span>{t(keys.welcomePage.halloween.text3)}</span>
                <Button as={'a'} className="halloween__description__button" href={`${window.location.origin}/main`}>
                    {t(keys.welcomePage.halloween.action)}
                </Button>
            </div>

        </div>
    }
    const trialGamesBanner = () => {
        const actionsCls = classnames('trial-games-banner__actions', {
            'trial-games-banner__actions--eng': lang === Languages.EN
        })
        return <div className="trial-games-banner--wrapper">
            <div className="trial-games-banner">
                <img className={'trial-games-banner__background'} src={'/WelcomePage/FreeGamesBanner/background.png'}/>
                <img className={'trial-games-banner__background'} src={'/WelcomePage/FreeGamesBanner/pattern.png'}/>
                <img className={'trial-games-banner__hero'} src={'/WelcomePage/FreeGamesBanner/heroIcon.png'}/>
                <div className="trial-games-banner__actions--wrapper">
                    <div className={actionsCls}>
                        <div className="actions__title">{t(keys.welcomePage.trialGamesBlock.title)}</div>
                        <div className="actions__title">{t(keys.welcomePage.trialGamesBlock.title2)}</div>
                        <div className="actions__description">{t(keys.welcomePage.trialGamesBlock.description)}</div>
                        <Button className="actions__button"
                                onClick={onToggle}>{t(keys.welcomePage.trialGamesBlock.tryToFree)}</Button>
                        {/*<div className="actions__button">Попробовать бесплатно</div>*/}
                    </div>

                </div>
                <div className="trial-games-banner__images">
                    <img className={'banner__images__tree1'} src={'/WelcomePage/FreeGamesBanner/tree1.png'}/>
                    <img className={'banner__images__tree2'} src={'/WelcomePage/FreeGamesBanner/tree2.png'}/>
                    <img className={'banner__images__vector'} src={'/WelcomePage/FreeGamesBanner/Vector.png'}/>
                </div>
            </div>

            <Modal open={isOpen} onOpen={onOpen} onClose={onClose}>
                <div className="trial-games__modal">
                    <div onClick={onToggle} className="modal__close-btn">
                        <div className="modal__close-btn__content">X</div>
                    </div>
                    <div className="modal__title">{t(keys.welcomePage.trialGamesBlock.modal.title)}</div>
                    <div className="modal__sub-title">{t(keys.welcomePage.trialGamesBlock.modal.title2)}</div>
                    <div className="modal__content">
                        <span>{t(keys.welcomePage.trialGamesBlock.modal.p)}<span
                            className={'vk'}>Вконтакте</span> {t(keys.welcomePage.trialGamesBlock.modal.p1)} <span
                            className={'discord'}>Discord</span></span>
                        <span>{t(keys.welcomePage.trialGamesBlock.modal.p2)} <span
                            className={'vk'}>VK</span> {t(keys.welcomePage.trialGamesBlock.modal.p1)} <span
                            className={'discord'}>Discord</span> {t(keys.welcomePage.trialGamesBlock.modal.p22)}</span>
                        <span>{t(keys.welcomePage.trialGamesBlock.modal.p3)}</span>
                        <span>{t(keys.welcomePage.trialGamesBlock.modal.p4)}</span>
                        {lang === Languages.CH && <span style={{overflowWrap: 'anywhere'}}>{t(keys.welcomePage.trialGamesBlock.modal.p5)}</span>}
                    </div>
                    <Button as={'a'} href={'https://vk.com/divinecheat'} target="_blank" className="modal__actions">Подписаться
                        на группу ВКонтакте</Button>
                </div>
            </Modal>

        </div>
    }

    const dashboard = () => {
        return <div className="welcome-page__dashboard">
            <Image webp={'/WelcomePage/dashboard.webp'} src={'/dashboard.png'}/>
            <Image webp={'/WelcomePage/dashboard-heroes.webp'} className={'dashboard--front'}
                   src={'/dashboard-heroes.png'}/>
        </div>
    }

    const onYoutubeVideoEndHandler = () => {
        // alert("video end")
        reSelectVideo();
        // console.log('reselect video')
    }

    const youtube = () => {

        return <div className="welcome-page__youtube">
            <div className="welcome-page__youtube__title">
                {t(keys.welcomePage.youtube.title)}
            </div>

            {/*<ReactPlayer muted playing width={'100%'}  loop*/}
            {/*             config={{*/}
            {/*                 youtube: {*/}
            {/*                     playerVars: {*/}
            {/*                         showInfo: 0,*/}
            {/*                         controls: 0*/}
            {/*                     },*/}
            {/*                     embedOptions: {*/}

            {/*                     }*/}
            {/*                 }*/}
            {/*             }}*/}
            {/*             url='https://youtu.be/qN18rGh8dyw' />*/}

            <div className="welcome-page__youtube__player player-wrapper">
                <ReactPlayer muted playing
                             width='100%'
                             onProgress={({played}) => {
                                 // console.log('onProgress', played)
                                 if (played >= 0.9) {
                                     onYoutubeVideoEndHandler();
                                 }
                             }}
                             height='100%'
                             loop={true}
                             className='react-player'
                             onEnded={onYoutubeVideoEndHandler}
                             config={{
                                 youtube: {
                                     playerVars: {
                                         showInfo: 0,
                                         controls: 0
                                     },
                                     embedOptions: {}
                                 }
                             }}
                    // url='https://youtu.be/CoLWsyLWoyI' />
                             url={links[selectedVideo]}/>
                <div className="welcome-page__youtube__overlay">
                    <div className="welcome-page__youtube__overlay__logo">
                        <div className="overlay__logo__item logo"><Image webp={'/WelcomePage/divine-logo-white.webp'}
                                                                         src='/divine-logo-white.png' alt={'logo'}/>
                        </div>
                        <div className="overlay__logo__item title">D I V I N E</div>
                    </div>
                    <div className="welcome-page__youtube__overlay__text">
                        {t(keys.welcomePage.youtube.text)}
                    </div>
                    <a target="_blank" href={'https://www.youtube.com/@divine-wtf'}
                       className="welcome-page__youtube__overlay__link">
                        <div className="overlay__link__icon">
                            <svg width="65" height="65" viewBox="0 0 65 65" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <circle cx="32.5" cy="32.5" r="32.5" fill="white"/>
                            </svg>
                            <svg className={'overlay__link__icon--in'} width="13" height="13" viewBox="0 0 13 13"
                                 fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 6.5L0.25 12.9952V0.00480938L13 6.5Z" fill="black"/>
                            </svg>
                        </div>
                        {t(keys.welcomePage.youtube.action)}
                    </a>

                </div>
            </div>

        </div>
    }

    const buySubBlock = () => {

        const buyItem = (preTitle: string, preTitle2: string, name: string, days: number, imageUrl: string) => {
            const price = subscriptionPrices.find(item => getPriceDays(item) === days);
            return <div className="buy__list__item">
                <Image className="buy__list__item__logo" src={imageUrl + '.png'} webp={imageUrl + '.webp'}/>
                {/*<img className="buy__list__item__logo" src={imageUrl}/>*/}
                <div className="buy__list__item__pre-title">
                    <span>{preTitle}</span>
                    <span>{` | `}</span>
                    <span>{preTitle2}</span>

                </div>
                <div className="buy__list__item__name">{name}</div>
                <div className="buy__list__item__info">
                    <div className="item__info__item">
                        <div className="item__info__title">{t(keys.welcomePage.buy.price)}</div>
                        <div className="item__info__value">{formatPrice(price)}</div>
                        {price && <span className="subscription-price-per-day">{t(keys.pricing.dailyAmount, {amount: formatPrice(price, true)})}</span>}
                    </div>
                    <div className="item__info__item">
                        <div className="item__info__title">{t(keys.welcomePage.buy.client)}</div>
                        <div className="item__info__value">Steam</div>
                    </div>
                </div>
                <div className="buy__list__item__action">
                    <div className="buy__list__item__action__icon">
                        <svg width="35" height="31" viewBox="0 0 35 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd"
                                  d="M17.5 3.10058C16.2596 3.10068 15.0514 3.47324 14.0504 4.16432C13.0494 4.8554 12.3076 5.82913 11.9322 6.9445L10.6179 10.8504H24.3821L23.0678 6.9445C22.6924 5.82913 21.9506 4.8554 20.9496 4.16432C19.9486 3.47324 18.7404 3.10068 17.5 3.10058ZM27.8289 10.8504L26.1991 6.00677C25.6131 4.26379 24.4541 2.74209 22.8901 1.66212C21.326 0.582154 19.4382 0 17.5 0C15.5618 0 13.674 0.582154 12.1099 1.66212C10.5459 2.74209 9.38691 4.26379 8.80089 6.00677L7.17114 10.8504H3.2857C2.77271 10.8504 2.26685 10.9638 1.80862 11.1813C1.35039 11.3989 0.952527 11.7147 0.646883 12.1034C0.341239 12.4921 0.136308 12.9429 0.0484964 13.4197C-0.0393148 13.8966 -0.00756568 14.3862 0.141201 14.8493L1.98781 20.5997L4.26815 27.6986C4.57485 28.6535 5.199 29.49 6.04837 30.0845C6.89774 30.679 7.92729 31 8.98489 31H26.0151C27.0724 30.9996 28.1016 30.6785 28.9506 30.084C29.7997 29.4895 30.4236 28.6532 30.7302 27.6986L33.0122 20.5997L34.8588 14.8493C35.0076 14.3862 35.0393 13.8966 34.9515 13.4197C34.8637 12.9429 34.6588 12.4921 34.3531 12.1034C34.0475 11.7147 33.6496 11.3989 33.1914 11.1813C32.7332 10.9638 32.2273 10.8504 31.7143 10.8504H27.8289ZM8.37209 13.9504H3.2857L4.77909 18.6003H10.9892L10.3156 13.9504H8.37209ZM13.6326 13.9504L14.3046 18.6003H20.6954L21.369 13.9504H13.631H13.6326ZM24.6844 13.9504L24.0108 18.6003H30.2209L31.7143 13.9504H24.6844ZM29.2253 21.7002H23.5623L22.6669 27.9001H26.0135C26.366 27.9001 26.7092 27.7931 26.9923 27.5949C27.2754 27.3967 27.4835 27.1179 27.5857 26.7996L29.2237 21.7002H29.2253ZM19.3515 27.9001L20.2469 21.7002H14.7514L15.6485 27.9001H19.3515ZM12.3315 27.9001L11.4361 21.7002H5.77468L7.41264 26.7996C7.51488 27.1179 7.72293 27.3967 8.00605 27.5949C8.28917 27.7931 8.63236 27.9001 8.98489 27.9001H12.3315Z"
                                  fill="white"/>
                        </svg>
                    </div>

                    <a className="buy__list__item__action__name" href={`${window.location.origin}/buy`}>
                        {t(keys.welcomePage.buy.action)}
                    </a>
                </div>
            </div>
        }

        return <div className="welcome-page__buy">
            <div className="welcome-page__buy--wrapper">
                <div className="welcome-page__buy__title">
                    {t(keys.welcomePage.buy.title)}
                </div>
                <div className="welcome-page__buy__list">
                    {buyItem(
                        t(keys.welcomePage.buy.item1.pre1),
                        t(keys.welcomePage.buy.item1.pre2),
                        t(keys.welcomePage.buy.item1.name),
                        7,
                        '/WelcomePage/7days'
                    )}
                    {buyItem(
                        t(keys.welcomePage.buy.item2.pre1),
                        t(keys.welcomePage.buy.item2.pre2),
                        t(keys.welcomePage.buy.item2.name),
                        14,
                        '/WelcomePage/14days'
                    )}
                    {buyItem(
                        t(keys.welcomePage.buy.item3.pre1),
                        t(keys.welcomePage.buy.item3.pre2),
                        t(keys.welcomePage.buy.item3.name),
                        30,
                        '/WelcomePage/30days'
                    )}
                    {buyItem(
                        t(keys.welcomePage.buy.item4.pre1),
                        t(keys.welcomePage.buy.item4.pre2),
                        t(keys.welcomePage.buy.item4.name),
                        90,
                        '/WelcomePage/90days'
                    )}
                </div>
            </div>

        </div>
    }


    return (
        <div className="welcome-page--base">
            <Scrollbars hideTracksWhenNotNeeded={true}>
                <div className="welcome-page--content">
                    {topPanel()}
                    {welcomeText()}
                    {carousel()}
                    {justDescription()}
                    {/**/}
                    {/*{halloween()}*/}
                    {/**/}
                    {trialGamesBanner()}
                    {/*{dashboard()}*/}
                    {youtube()}
                    {buySubBlock()}
                    <PaymentsList/>
                    <Footer/>
                </div>

                {/*<div className="welcome-page">*/}
                {/*    <div className="welcome-page-gradient"/>*/}
                {/*    <svg className={'welcome-page-gradient'} width="807" height="945" viewBox="0 0 807 945" fill="none"*/}
                {/*         xmlns="http://www.w3.org/2000/svg">*/}
                {/*        <circle cx="-36.5" cy="101.5" r="843.5" fill="url(#paint0_radial)"/>*/}
                {/*        <defs>*/}
                {/*            <radialGradient id="paint0_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"*/}
                {/*                            gradientTransform="translate(-36.5 101.5) rotate(90) scale(704.551)">*/}
                {/*                <stop stopColor="#FF0909"/>*/}
                {/*                <stop offset="1" stopColor="#4200FF" stopOpacity="0"/>*/}
                {/*            </radialGradient>*/}
                {/*        </defs>*/}
                {/*    </svg>*/}

                {/*    <div className={getStickyTopClasses()}>*/}
                {/*        <div className="divine-main-icon"></div>*/}
                {/*        <Image className="icon" src='/divine-main.png' webp='/divine-main.webp' alt={'DIVINE'}/>*/}
                {/*        <div className="line">DIVINE</div>*/}
                {/*        <div className="spacer"/>*/}
                {/*        <div className="links">*/}
                {/*            <NavLink className="link simple" exact to='/about'>{t(keys.welcomePage.aboutUs)}</NavLink>*/}

                {/*            <NavLink className="link" exact to='/agreement'>{t(keys.welcomePage.agreement)}</NavLink>*/}
                {/*            <NavLink className="link" exact to='/privacy'>{t(keys.welcomePage.privacy)}</NavLink>*/}
                {/*            <NavLink className="link" exact to='/contacts'>{t(keys.welcomePage.contacts)}</NavLink>*/}
                {/*            <NavLink className="link" exact to='/videos'>Видео</NavLink>*/}
                {/*            <Link to="route" target="_blank" className="link simple" onClick={(event) => {*/}
                {/*                event.preventDefault();*/}
                {/*                window.open('https://vk.com/divinecheat');*/}
                {/*            }}>VK</Link>*/}
                {/*            <Link to="route" target="_blank" className="link simple" onClick={(event) => {*/}
                {/*                event.preventDefault();*/}
                {/*                window.open('https://discord.gg/YvFuC6H');*/}
                {/*            }}>Discord</Link>*/}
                {/*            <div className="link" onClick={onLogin}>{t(keys.welcomePage.login)}</div>*/}
                {/*            <div className="link" onClick={onLogin}>*/}
                {/*                <div className="sign-up">*/}
                {/*                    {t(keys.welcomePage.signUp)}*/}
                {/*                </div>*/}
                {/*            </div>*/}

                {/*            <NavLink className="link" exact to='/login'>Login</NavLink>*/}
                {/*            <NavLink className="link" exact to='/login'>*/}
                {/*                <div className="sign-up">*/}
                {/*                    Sign Up*/}
                {/*                </div>*/}
                {/*            </NavLink>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*    <img src="/kunka2.png" alt="" className="all-shit"/>*/}
                {/*    <Image*/}
                {/*        className="all-shit"*/}
                {/*        src={'/kunka2.png'}*/}
                {/*        webp={'/kunka2.webp'}*/}
                {/*    />*/}
                {/*    <img src="https://i.imgur.com/5ZXTAwI.png" alt="" className="all-shit"/>*/}
                {/*    <div className="welcome-page-content">*/}
                {/*        <div className="all-shit"></div>*/}

                {/*        <div className="all-shit"></div>*/}

                {/*        <div className="title-with-text">*/}
                {/*            <div className="title">{t(keys.welcomePage.tryCheat)}</div>*/}
                {/*            <div className="text">{t(keys.welcomePage.dontOpenMouths)}</div>*/}
                {/*            <div className="reg-block">*/}
                {/*                <div className="now">{t(keys.welcomePage.registerNow)}</div>*/}
                {/*                <div className="arrow">*/}
                {/*                    <svg width="166" height="23" viewBox="0 0 166 23" fill="none"*/}
                {/*                         xmlns="http://www.w3.org/2000/svg">*/}
                {/*                        <path*/}
                {/*                            d="M165.062 12.5607C165.648 11.9749 165.648 11.0251 165.062 10.4393L155.516 0.893398C154.93 0.307611 153.981 0.307611 153.395 0.893398C152.809 1.47919 152.809 2.42893 153.395 3.01472L161.88 11.5L153.395 19.9853C152.809 20.5711 152.809 21.5208 153.395 22.1066C153.981 22.6924 154.93 22.6924 155.516 22.1066L165.062 12.5607ZM0.998474 13H164.002V10H0.998474V13Z"*/}
                {/*                            fill="#9DA4B7"/>*/}
                {/*                    </svg>*/}
                {/*                </div>*/}
                {/*                <div className="reg-btn">*/}
                {/*                    <div className="text btn" onClick={onLogin}>{t(keys.welcomePage.registration)}</div>*/}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*        <div className="second">*/}
                {/*            The program is distributed free of charge until the full release*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<div className="gradient-block">*/}
                {/*    <BasicTopNavBar show={top > 0.44} headerText={t(keys.welcomePage.feature)}/>*/}
                {/*    <div className="functions">*/}

                {/*        <div className="functions-content">*/}
                {/*            <div className="forge">*/}
                {/*                <img className="icon" src="/forge-spirit-temp.png" alt={'divine'}/>*/}
                {/*                <Image*/}
                {/*                    className="icon"*/}
                {/*                    src={'/forge-spirit-temp.png'}*/}
                {/*                    webp={'/forge-spirit-temp.webp'}*/}
                {/*                />*/}
                {/*            </div>*/}
                {/*            <div className="text-two">*/}
                {/*                {t(keys.welcomePage.optimized)}*/}
                {/*                {t(keys.welcomePage.littleFps)}*/}
                {/*            </div>*/}
                {/*            <div className="text-one">*/}
                {/*                {t(keys.welcomePage.cool)}*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*        <div className="functions-gradient-container">*/}

                {/*            <svg className={'functions-gradient'} width="807" height="945" viewBox="0 0 807 945" fill="none"*/}
                {/*                 xmlns="http://www.w3.org/2000/svg">*/}
                {/*                <circle cx="-36.5" cy="101.5" r="843.5" fill="url(#paint0_radial)"/>*/}
                {/*                <defs>*/}
                {/*                    <radialGradient id="paint0_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"*/}
                {/*                                    gradientTransform="translate(-36.5 101.5) rotate(90) scale(704.551)">*/}
                {/*                        <stop stopColor="#FF0909"/>*/}
                {/*                        <stop offset="1" stopColor="#4200FF" stopOpacity="0"/>*/}
                {/*                    </radialGradient>*/}
                {/*                </defs>*/}
                {/*            </svg>*/}
                {/*        </div>*/}

                {/*    </div>*/}
                {/*    <SubInfoBlock/>*/}
                {/*    <PaymentsList/>*/}
                {/*</div>*/}
                {/*<Footer/>*/}
            </Scrollbars>
        </div>
    )
}

export default WelcomePage;
